import { useState, useEffect } from 'react'

import { useEnvs } from '@marketplace-web/environment/environment-util'
import { GOOGLE_MAPS_API_KEY } from '@marketplace-web/shipping/google-maps-data'

import { loadGoogleApi, removeGoogleCallback } from './loadGoogleApi'

const useLoadGoogleApi = () => {
  const googleApiKey = useEnvs(GOOGLE_MAPS_API_KEY)

  const [isGoogleApiLoaded, setIsGoogleApiLoaded] = useState(false)

  useEffect(() => {
    if (!googleApiKey) return undefined

    const handleGoogleApiLoaded = () => setIsGoogleApiLoaded(true)

    if (typeof window?.google?.maps !== 'undefined') return setIsGoogleApiLoaded(true)

    loadGoogleApi({
      apiKey: googleApiKey,
      onGoogleApiLoaded: handleGoogleApiLoaded,
    })

    return () => removeGoogleCallback(handleGoogleApiLoaded)
  }, [googleApiKey])

  return isGoogleApiLoaded
}

export default useLoadGoogleApi
